const empty = [];

// export { default as beauty } from './beauty';
// export { default as books } from './books';
// export { default as electronics } from './electronics';
// export { default as fashion } from './fashion';
// export { default as fitness } from './fitness';
// export { default as games } from './games';
// export { default as home } from './home';
export { default as places } from './places';
// export { default as music } from './music';
export { default as restaurants } from './restaurants';
export { default as movies } from './movies';
export { default as series } from './series';

export const beauty = empty;
export const books = empty;
export const electronics = empty;
export const fashion = empty;
export const fitness = empty;
export const games = empty;
export const home = empty;
export const music = empty;
export const videogames = empty;
